var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/pro-solid-svg-icons";
import { Input, Option, Select, } from "@mui/joy";
import { useEffect, useState } from "react";
import { FieldViewType } from "@/components/fields/viewType";
import { useTranslation } from "react-i18next";
import DateFieldEdit from "@/components/fields/date/edit";
import { useSaveDashletPreferencesMutation, useSearchDashletChartMutation, } from "@/store/api";
import { LoaderImage } from "@/utils/loader";
export default function EditChart(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    var isOpen = _a.isOpen, onClose = _a.onClose, title = _a.title, records = _a.records, id = _a.id;
    var data = records === null || records === void 0 ? void 0 : records.rowMeta;
    var rowID = records === null || records === void 0 ? void 0 : records.rowId;
    var _x = useState(data), rowMeta = _x[0], setRowMeta = _x[1];
    var _y = useState((_b = records === null || records === void 0 ? void 0 : records.payload) === null || _b === void 0 ? void 0 : _b.allDashlets), allDashlets = _y[0], setAllDashlets = _y[1];
    var _z = useState("key"), key = _z[0], setKey = _z[1];
    var record = data === null || data === void 0 ? void 0 : data.find(function (item) { return item.id === id; });
    var _0 = useState(title), titleChart = _0[0], setTitleChart = _0[1];
    var _1 = useState((_d = (_c = rowMeta === null || rowMeta === void 0 ? void 0 : rowMeta.find(function (item) { return item.id === id; })) === null || _c === void 0 ? void 0 : _c.refresh) !== null && _d !== void 0 ? _d : -1), refresh = _1[0], setRefresh = _1[1];
    useEffect(function () {
        var _a;
        setRefresh((_a = rowMeta === null || rowMeta === void 0 ? void 0 : rowMeta.find(function (item) { return item.id === id; })) === null || _a === void 0 ? void 0 : _a.refresh);
    }, [rowMeta]);
    var t = useTranslation(["common", "Charts"]).t;
    var _2 = useState(((_f = (_e = rowMeta === null || rowMeta === void 0 ? void 0 : rowMeta.find(function (item) { return item.id === id; })) === null || _e === void 0 ? void 0 : _e.searchedData) === null || _f === void 0 ? void 0 : _f.dateRange) || {}), recordsData = _2[0], setRecordsData = _2[1];
    var getSixMonthsAhead = function () {
        var today = new Date();
        today.setMonth(today.getMonth() + 6);
        return today.toISOString().split("T")[0];
    };
    var getValidDate = function (dateString, field) {
        if (field.name.endsWith("_end")) {
            return getSixMonthsAhead();
        }
        if (!dateString ||
            typeof dateString !== "string" ||
            dateString === undefined) {
            return new Date().toISOString().split("T")[0];
        }
        var isoDateMatch = /^\d{4}-\d{2}-\d{2}$/.test(dateString);
        if (!isoDateMatch) {
            return new Date().toISOString().split("T")[0];
        }
        var parsedDate = new Date(dateString);
        if (isNaN(parsedDate.getTime())) {
            return new Date().toISOString().split("T")[0];
        }
        return parsedDate.toISOString().split("T")[0];
    };
    var appLists = t("app_lists");
    var leadSourceDom = (appLists === null || appLists === void 0 ? void 0 : appLists.lead_source_dom) || {};
    var sales_stage_dom = (appLists === null || appLists === void 0 ? void 0 : appLists.sales_stage_dom) || {};
    var options = {
        users: Object.entries(((_g = record === null || record === void 0 ? void 0 : record.chartData) === null || _g === void 0 ? void 0 : _g.users) || {}),
        leadSources: Object.entries(leadSourceDom || {}),
        salesStages: Object.entries(sales_stage_dom || {}),
    };
    var _3 = useState({
        users: ((_l = (_k = (_j = (_h = rowMeta.find(function (item) { return item.id === id; })) === null || _h === void 0 ? void 0 : _h.searchedData) === null || _j === void 0 ? void 0 : _j.selectedOptions.users) !== null && _k !== void 0 ? _k : options.users.map(function (_a) {
            var key = _a[0];
            return key;
        })) !== null && _l !== void 0 ? _l : []).map(function (opt) { return (opt === "" ? "Unknown" : opt); }),
        leadSources: ((_q = (_p = (_o = (_m = rowMeta.find(function (item) { return item.id === id; })) === null || _m === void 0 ? void 0 : _m.searchedData) === null || _o === void 0 ? void 0 : _o.selectedOptions.leadSources) !== null && _p !== void 0 ? _p : options.leadSources.map(function (_a) {
            var key = _a[0];
            return key;
        })) !== null && _q !== void 0 ? _q : []).map(function (opt) { return (opt === "" ? "Unknown" : opt); }),
        salesStages: ((_u = (_t = (_s = (_r = rowMeta.find(function (item) { return item.id === id; })) === null || _r === void 0 ? void 0 : _r.searchedData) === null || _s === void 0 ? void 0 : _s.selectedOptions.salesStages) !== null && _t !== void 0 ? _t : options.salesStages.map(function (_a) {
            var key = _a[0];
            return key;
        })) !== null && _u !== void 0 ? _u : []).map(function (opt) { return (opt === "" ? "Unknown" : opt); }),
    }), selectedOptions = _3[0], setSelectedOptions = _3[1];
    var handleSelectionChange = function (key, newValue) {
        setSelectedOptions(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = newValue, _a)));
        });
    };
    var _4 = useSaveDashletPreferencesMutation(), saveDashletPreferences = _4[0], _5 = _4[1], dashletLoad = _5.isLoading, isError = _5.isError;
    var searchDashletChart = useSearchDashletChartMutation()[0];
    var searchDashlet = function () { return __awaiter(_this, void 0, void 0, function () {
        var requestData, searchFields, result, err_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    requestData = {};
                    searchFields = ((_b = (_a = rowMeta.find(function (item) { return item.id === id; })) === null || _a === void 0 ? void 0 : _a.chartData) === null || _b === void 0 ? void 0 : _b.searchFields) ||
                        {};
                    Object.entries(searchFields).forEach(function (_a) {
                        var key = _a[0], field = _a[1];
                        switch (key) {
                            case "obm_ids":
                                requestData.obm_ids = selectedOptions.users;
                                requestData.obm_date_start = (recordsData === null || recordsData === void 0 ? void 0 : recordsData.obm_date_start) || "";
                                requestData.obm_date_end = (recordsData === null || recordsData === void 0 ? void 0 : recordsData.obm_date_end) || "";
                                break;
                            case "lsbo_lead_sources":
                                requestData.lsbo_ids = selectedOptions.users;
                                requestData.lsbo_lead_sources = selectedOptions.leadSources;
                                break;
                            case "pbls_ids":
                                requestData.pbls_ids = selectedOptions.users;
                                requestData.pbls_lead_sources = selectedOptions.leadSources;
                                break;
                            case "pbss_sales_stages":
                                requestData.pbss_sales_stages = selectedOptions.salesStages;
                                requestData.pbss_date_start = (recordsData === null || recordsData === void 0 ? void 0 : recordsData.pbss_date_start) || "";
                                requestData.pbss_date_end = (recordsData === null || recordsData === void 0 ? void 0 : recordsData.pbss_date_end) || "";
                                break;
                            case "mypbss_sales_stages":
                                requestData.mypbss_sales_stages = selectedOptions.salesStages;
                                requestData.mypbss_date_start = (recordsData === null || recordsData === void 0 ? void 0 : recordsData.mypbss_date_start) || "";
                                requestData.mypbss_date_end = (recordsData === null || recordsData === void 0 ? void 0 : recordsData.mypbss_date_end) || "";
                                break;
                            default:
                                break;
                        }
                    });
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, searchDashletChart({ body: requestData }).unwrap()];
                case 2:
                    result = _c.sent();
                    return [2 /*return*/, result];
                case 3:
                    err_1 = _c.sent();
                    console.error("Error searching dashlet chart:", err_1);
                    throw err_1;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
        var resultSearch, newChartData_1, searchFields_1, updatedDashlets_1, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, searchDashlet()];
                case 1:
                    resultSearch = _d.sent();
                    newChartData_1 = (_a = resultSearch === null || resultSearch === void 0 ? void 0 : resultSearch.data) === null || _a === void 0 ? void 0 : _a.dashlets;
                    setKey(Date.now());
                    if (!newChartData_1) {
                        onClose();
                        return [2 /*return*/];
                    }
                    searchFields_1 = ((_c = (_b = rowMeta.find(function (item) { return item.id === id; })) === null || _b === void 0 ? void 0 : _b.chartData) === null || _c === void 0 ? void 0 : _c.searchFields) ||
                        {};
                    updatedDashlets_1 = rowMeta.map(function (dashlet) {
                        return dashlet.id === id
                            ? __assign(__assign({}, dashlet), { chartData: __assign({}, newChartData_1), title: titleChart, searchedData: {
                                    selectedOptions: Object.keys(searchFields_1).some(function (key) { return key === "obm_ids"; })
                                        ? { users: selectedOptions.users }
                                        : Object.keys(searchFields_1).some(function (key) {
                                            return ["lsbo_lead_sources", "pbls_ids"].includes(key);
                                        })
                                            ? {
                                                users: selectedOptions.users,
                                                leadSources: selectedOptions.leadSources,
                                            }
                                            : Object.keys(searchFields_1).some(function (key) {
                                                return ["pbss_sales_stages", "mypbss_sales_stages"].includes(key);
                                            })
                                                ? { salesStages: selectedOptions.salesStages }
                                                : null,
                                    dateRange: recordsData,
                                }, refresh: refresh }) : dashlet;
                    });
                    setAllDashlets(function (prevDashlets) {
                        var updatedDashletsState = __assign({}, prevDashlets);
                        for (var key_1 in updatedDashletsState) {
                            if (updatedDashletsState[key_1].id === rowID) {
                                updatedDashletsState[key_1] = __assign(__assign({}, updatedDashletsState[key_1]), { meta: updatedDashlets_1 });
                                break;
                            }
                        }
                        updatedDashletsState &&
                            saveDashletPreferences({
                                dashlets: updatedDashletsState,
                                isNew: false,
                            })
                                .unwrap()
                                .then(function () { return onClose(); })
                                .catch(function (error) {
                                console.error("Failed to save dashlet preference:", error);
                            });
                        return updatedDashletsState;
                    });
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _d.sent();
                    console.error("Failed to fetch chart data:", error_1);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("div", __assign({ className: "fixed inset-0 flex items-center justify-center bg-gray-950 bg-opacity-50 z-50 " }, { children: _jsxs("div", __assign({ className: " bg-[var(--colors-background-popup-sec)] p-5 rounded-lg shadow-lg relative w-1/3 " }, { children: [dashletLoad && _jsx(LoaderImage, {}), _jsxs("div", __assign({ className: "flex justify-between items-center border-b pb-2" }, { children: [_jsx("h2", __assign({ className: "text-lg font-semibold" }, { children: titleChart })), _jsx("button", __assign({ onClick: onClose, className: "text-gray-500 hover:text-red-500" }, { children: _jsx(FontAwesomeIcon, { icon: faClose }) }))] })), _jsxs("div", __assign({ className: "py-3 space-y-3 w-full" }, { children: [_jsxs("div", __assign({ className: "flex justify-between items-center w-full space-x-2" }, { children: [_jsx("label", __assign({ className: "" }, { children: t("app.LBL_AUTOMATIC_REFRESH") })), _jsx(Input, { className: "w-1/2", value: titleChart, onChange: function (e) {
                                        setTitleChart(e.target.value);
                                    } })] })), _jsxs("div", __assign({ className: "flex justify-between items-center w-full space-x-2" }, { children: [_jsx("label", __assign({ className: "" }, { children: t("app.LBL_TITLE_TEXT") })), _jsx("span", __assign({ className: "w-1/2" }, { children: _jsxs(Select, __assign({ defaultValue: refresh, onChange: function (e, value) {
                                            setRefresh(value);
                                        } }, { children: [_jsx(Option, __assign({ value: -1 }, { children: t("app.LBL_NONE") })), _jsx(Option, __assign({ value: 30000 }, { children: t("app.LBL_REFRESH_30_SECONDS") })), _jsx(Option, __assign({ value: 60000 }, { children: t("app.LBL_REFRESH_1_MINUTE") })), _jsx(Option, __assign({ value: 120000 }, { children: t("app.LBL_REFRESH_3_MINUTES") })), _jsx(Option, __assign({ value: 300000 }, { children: t("app.LBL_REFRESH_5_MINUTES") })), _jsx(Option, __assign({ value: 600000 }, { children: t("app.LBL_REFRESH_10_MINUTES") }))] })) }))] })), ((_v = record === null || record === void 0 ? void 0 : record.chartData) === null || _v === void 0 ? void 0 : _v.searchFields) &&
                            Object.entries((_w = record === null || record === void 0 ? void 0 : record.chartData) === null || _w === void 0 ? void 0 : _w.searchFields).map(function (_a) {
                                var _b;
                                var key = _a[0], field = _a[1];
                                var fieldLabel = t(field.vname, { ns: "Charts" });
                                var renderSelect = function (key, field, selectedKey, optionsKey) {
                                    var _a;
                                    return (_jsxs("div", __assign({ className: "flex justify-between items-center w-full space-x-2" }, { children: [_jsx("label", { children: fieldLabel }), _jsx("span", __assign({ className: "w-1/2" }, { children: _jsx(Select, __assign({ multiple: true, value: (_a = selectedOptions[selectedKey]) !== null && _a !== void 0 ? _a : [], onChange: function (event, newValue) {
                                                        return handleSelectionChange(selectedKey, newValue);
                                                    }, placeholder: "Select source..." }, { children: options[optionsKey].map(function (_a) {
                                                        var value = _a[0], label = _a[1];
                                                        return label === "" ? (_jsx(Option, __assign({ value: "Unknown" }, { children: t("app.LBL_UNKNOWN") }), "")) : (_jsx(Option, __assign({ value: value }, { children: label }), value));
                                                    }) })) }))] }), key));
                                };
                                if (field.type !== "enum" && field.type !== "user_name") {
                                    if (field.type === "datepicker") {
                                        return (_jsxs("div", __assign({ className: "flex justify-between items-center w-full space-x-2 " }, { children: [_jsx("label", { children: fieldLabel }), _jsx("span", __assign({ className: "w-1/2 " }, { children: _jsx(DateFieldEdit, { className: "relative z-[100]", viewType: FieldViewType.EDIT, record: __assign(__assign({}, recordsData), (_b = {}, _b[field.name] = getValidDate(recordsData === null || recordsData === void 0 ? void 0 : recordsData[field.name], field), _b)), fieldName: field.name, fieldMetadata: {
                                                            type: "date",
                                                            name: field.name,
                                                            module: field.name.includes("LBL_")
                                                                ? t(field.vname, { ns: "Users" })
                                                                : "",
                                                        }, onUpdate: function (value) {
                                                            var selectedDate = value === null || value === void 0 ? void 0 : value[field.name];
                                                            if (!selectedDate ||
                                                                isNaN(new Date(selectedDate).getTime())) {
                                                                console.warn("Invalid date detected, defaulting to today's date:", selectedDate);
                                                                setRecordsData(function (prevState) {
                                                                    var _a;
                                                                    return (__assign(__assign({}, prevState), (_a = {}, _a[field.name] = new Date()
                                                                        .toISOString()
                                                                        .split("T")[0], _a)));
                                                                });
                                                                return;
                                                            }
                                                            var localDate = new Date(selectedDate);
                                                            localDate.setMinutes(localDate.getMinutes() -
                                                                localDate.getTimezoneOffset());
                                                            if (localDate) {
                                                                setRecordsData(function (prevState) {
                                                                    var _a;
                                                                    return (__assign(__assign({}, prevState), (_a = {}, _a[field.name] = localDate
                                                                        .toISOString()
                                                                        .split("T")[0], _a)));
                                                                });
                                                            }
                                                        }, isEditable: true }, key) }))] })));
                                    }
                                    else {
                                        return _jsx(_Fragment, {});
                                    }
                                }
                                if (field.type === "user_name") {
                                    return renderSelect(key, field, "users", "users");
                                }
                                if (field.type === "enum") {
                                    if (key === "lsbo_lead_sources" ||
                                        key === "pbls_lead_sources") {
                                        return renderSelect(key, field, "leadSources", "leadSources");
                                    }
                                    if (key === "mypbss_sales_stages" ||
                                        key === "pbss_sales_stages") {
                                        return renderSelect(key, field, "salesStages", "salesStages");
                                    }
                                }
                                return null;
                            })] })), _jsxs("div", __assign({ className: "flex justify-end space-x-2 border-t pt-2" }, { children: [_jsx("button", __assign({ onClick: handleSave, className: "bg-[var(--colors-button-success)] text-sm text-[var(--colors-label)] px-4 py-2 rounded-md hover:bg-[var(--colors-button-success--hover)]" }, { children: t("app.LBL_SAVE_BUTTON_LABEL", { ns: "common" }) })), _jsx("button", __assign({ onClick: onClose, className: "text-[var(--colors-label)] text-sm bg-[var(--colors-button-info)] px-4 py-2 rounded-md hover:bg-[var(--colors-button-info--hover)]" }, { children: t("app.LBL_CLEAR_BUTTON_LABEL") }))] }))] })) }), key));
}
